export default {
	methods: {
		syntaxHighlight(json) {
			if (typeof json != 'string') {
				json = JSON.stringify(json, undefined, 2);
			}
			json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
			return json.replace(
					/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
					function (match) {
						var cls = 'number';
						if (/^"/.test(match)) {
							if (/:$/.test(match)) {
								cls = 'text-black';
							} else {
								cls = 'text-primary';
							}
						} else if (/true|false/.test(match)) {
							cls = 'text-success';
						} else if (/null/.test(match)) {
							cls = 'text-info';
						}
						return '<span class="' + cls + '">' + match + '</span>';
					}).replaceAll(',', '</br>')
				.replaceAll('{', '<div class="p-3">')
				.replaceAll('}', '</div>')
				.replaceAll('[', '<div class="px-3">')
				.replaceAll(']', '</div>')
				.replaceAll('"', ' ')
		},
	},
}